module.exports = __webpack_public_path__ + "static/media/ProximaNova-Regular.4b7bc2c6.eot";